import { render } from "./InputMonth.vue?vue&type=template&id=e698052a"
import script from "./InputMonth.vue?vue&type=script&lang=js"
export * from "./InputMonth.vue?vue&type=script&lang=js"
script.render = render

export default script